import React from 'react';
import './Services.css';

const entryPackages = [
  {
    badge: 'Free · No obligation',
    title: 'Free 30-Min Delivery Audit',
    description:
      'I review your project or IT environment and identify the top three failure points blocking progress. No cost, no commitment - just clarity on what to fix first.',
    cta: 'Book Free Audit',
    href: '#work-with-me',
    highlight: true,
  },
  {
    badge: 'Quick Engagement',
    title: 'Project Rescue',
    description:
      'For projects already delayed or stalled. I diagnose root causes, restructure delivery, and get execution back on track - fast.',
    cta: 'Rescue My Project',
    href: '#work-with-me',
    highlight: false,
  },
  {
    badge: 'IT Stability',
    title: 'System Stability Assessment',
    description:
      'I audit your IT environment for downtime risks, recurring incidents, and support gaps - then give you a prioritised, actionable fix plan.',
    cta: 'Request Assessment',
    href: '#work-with-me',
    highlight: false,
  },
];

const projects = [
  {
    src: '/Project1.jpg',
    alt: 'Project snapshot 1',
    name: 'Digital Banking Transformation Project',
  },
  {
    src: '/Project2.jpg',
    alt: 'Project snapshot 2',
    name: 'Enterprise Network Infrastructure Upgrade',
  },
  {
    src: '/Project%203.jpg',
    alt: 'Project snapshot 3',
    name: 'Fintech Platform Deployment – Solv Ghana',
  },
];

export default function Services() {
  return (
    <section className="section services anchor" id="services">
      <div className="container">
        <header className="services__header">
          <h2 className="services__title">Services</h2>
          <p className="services__subtitle">
            Not sure where to start? Pick an entry point below - or scroll down to see the full
            service breakdown.
          </p>
        </header>

        {/* Entry packages - the fastest way to engage */}
        <div className="services__packages" aria-label="Entry packages">
          {entryPackages.map((pkg) => (
            <div
              className={['services__package', pkg.highlight ? 'services__package--highlight' : '']
                .join(' ')
                .trim()}
              key={pkg.title}
            >
              <div className="services__packageBadge">{pkg.badge}</div>
              <h3 className="services__packageTitle">{pkg.title}</h3>
              <p className="services__packageDesc">{pkg.description}</p>
              <a className="services__packageCta" href={pkg.href}>
                {pkg.cta} →
              </a>
            </div>
          ))}
        </div>

        <div className="services__divider" aria-hidden />

        <h3 className="services__sectionLabel">Full Service Breakdown</h3>

        <div className="services__grid">
          <article className="services__card">
            <h3>Project Management</h3>
            <p>
              End-to-end delivery leadership using Agile, Scrum, and structured risk management - so
              your team ships on time without chaos.
            </p>
            <div className="services__split">
              <div>
                <h4>What I Do</h4>
                <ul>
                  <li>End-to-end project planning and execution</li>
                  <li>Agile & Scrum sprint leadership</li>
                  <li>Risk identification and change management</li>
                  <li>Stakeholder coordination and weekly reporting</li>
                  <li>Delivery rescue for stalled or late projects</li>
                </ul>
              </div>
              <div>
                <h4>Tools</h4>
                <div className="services__tags" aria-label="Tools">
                  <span className="services__tag">Jira</span>
                  <span className="services__tag">Microsoft Project</span>
                  <span className="services__tag">Monday.com</span>
                  <span className="services__tag">ClickUp</span>
                  <span className="services__tag">Asana</span>
                  <span className="services__tag">Confluence</span>
                </div>
              </div>
            </div>
          </article>

          <article className="services__card">
            <h3>IT Support &amp; Infrastructure</h3>
            <p>
              I troubleshoot, stabilise, and improve IT support processes - using ITIL-based service
              management to cut downtime and eliminate recurring incidents.
            </p>
            <div className="services__split">
              <div>
                <h4>What I Do</h4>
                <ul>
                  <li>Network and systems troubleshooting</li>
                  <li>Application and production support</li>
                  <li>ITIL 4 service management implementation</li>
                  <li>Security monitoring and incident response</li>
                  <li>Escalation process design and improvement</li>
                </ul>
              </div>
              <div>
                <h4>Best For</h4>
                <ul>
                  <li>Teams with high incident volumes</li>
                  <li>Reducing downtime and repeat failures</li>
                  <li>Stabilising environments during product scaling</li>
                  <li>Building reliable support coverage</li>
                </ul>
              </div>
            </div>
          </article>
        </div>

        <div className="services__gallery" aria-label="Project images">
          {projects.map((p) => (
            <figure className="services__galleryItem" key={p.src}>
              <img className="services__galleryImg" src={p.src} alt={p.alt} loading="lazy" />
              <figcaption className="services__galleryCaption">{p.name}</figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
